import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getRequiredRoles } from '../config/routePermissions';
import {ProtectedRouteProps} from "../model";
import {useAuth} from "../services";

/**
 * ProtectedRoute Component
 * 
 * A wrapper component that checks if the user is authenticated
 * and has the required role to access the route.
 * Redirects to the login page if not authenticated,
 * or to the home page if authenticated but lacking permission.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles }) => {
  const { isAuthenticated, hasAccess } = useAuth();
  const location = useLocation();
  
  // 如果用戶未登入，重定向到登入頁面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  // 如果沒有指定所需角色，從路由模式中求出
  const path = location.pathname;
  const roles = requiredRoles || getRequiredRoles(path);
  
  // 如果用戶沒有權限訪問該路由，重定向到首頁
  if (!hasAccess(roles)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
